export default __webpack_public_path__ + "images/093fa115120f7d6672a640b78db76162.svg";